import { OutsideClick, Popup, PopupArrow } from '@cian/components';
import * as React from 'react';

import * as styles from './PopupAutoChangeToSuburban.css';

interface IPopupAutoChangeToSuburbanProps {
  hidePopupAutoChangeToSuburban(): void;
}

export function PopupAutoChangeToSuburban(props: IPopupAutoChangeToSuburbanProps) {
  const { hidePopupAutoChangeToSuburban } = props;

  return (
    <OutsideClick
      onOutsideClick={() => {
        hidePopupAutoChangeToSuburban();
      }}
    >
      <Popup arrow={PopupArrow.NONE} containerStyle={styles['popup']}>
        Тип недвижимости изменен, потому что вы выбрали коттеджный поселок.
      </Popup>
    </OutsideClick>
  );
}
